// extracted by mini-css-extract-plugin
export default {"co-verbiag":"CopayAnalytics_co-verbiag__FMuGO"};